<template lang="pug">
  self-layout
    template(#add)
      self-add
    template(#list)
      self-list
</template>

<script>
import SelfLayout from './layout/'
import SelfAdd from './add/'
import SelfList from './list/'
import { page } from '@iez/core'

const route = {
  name: 'ManageAssociations',
  path: '/manage-associations'
}

export default {
  ...route,

  components: {
    SelfLayout,
    SelfAdd,
    SelfList
  },

  setup () {
    page.topBar.set({
      route,
      title: `Gestion des associations`
    })
  }
}
</script>
